"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterReact = exports.Footer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../store/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FooterReact = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FooterReact, _React$PureComponent);
  var _super = _createSuper(FooterReact);
  function FooterReact() {
    (0, _classCallCheck2.default)(this, FooterReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(FooterReact, [{
    key: "render",
    value: function render() {
      var siteInfo = this.props.siteInfo;
      var containerClass = siteInfo && (siteInfo.realm === _constants.LCYTS || siteInfo.realm === _constants.LCK12) ? 'yts-global-footer' : siteInfo && siteInfo.realm === _constants.LCPS ? 'lcps-global-footer' : 'global-footer';
      var privacyLink = siteInfo && siteInfo.privacyLink ? siteInfo.privacyLink : '/patientsolutions/privacy';
      var cprTxtArray = siteInfo && siteInfo.cprTxtArray ? siteInfo.cprTxtArray : ['Credit Accounts with a promotional plan are issued by Comenity Capital Bank, Member FDIC. Fixed Rate Plan loans are issued by NBT Bank, N.A., Member FDIC.', '&ldquo;LendingClub&rdquo; and the &ldquo;LC&rdquo; symbol, and &ldquo;Radius&rdquo; and the &ldquo;R&rdquo; symbol, are trademarks of LendingClub Bank, N.A., Member FDIC (&ldquo;LendingClub Bank&rdquo;), a wholly-owned subsidiary of LendingClub Corporation, NMLS ID 167439.', '&copy; 2021 LendingClub Bank. All rights reserved. <span class="footer-housing-lender"></span> Equal Housing Lender'];
      return /*#__PURE__*/_react.default.createElement("footer", {
        className: containerClass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "footer-content text-white"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "links-list"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: privacyLink,
        target: "_blank",
        rel: "noreferrer"
      }, "Privacy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "/legal/terms-of-use",
        target: "_blank"
      }, "Terms of Use")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "/legal/accessibility",
        target: "_blank"
      }, "Accessibility"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "copyright"
      }, cprTxtArray.map(function (__html, index) {
        return /*#__PURE__*/_react.default.createElement("p", {
          key: "footer_content_".concat(index),
          dangerouslySetInnerHTML: {
            __html: __html
          }
        });
      }))));
    }
  }]);
  return FooterReact;
}(_react.default.PureComponent);
exports.FooterReact = FooterReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo
  };
};
FooterReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Footer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FooterReact);
exports.Footer = Footer;
